import { useState } from 'react';
import SignInForm from '../components/auth/SignInForm';
import AuthHeroImage from '../components/auth/AuthHeroImage';
import RegisterModal from '../components/auth/RegisterModal';
import OtpModal from '../components/auth/OtpModal';
import SuccessModal from '../components/auth/SuccessModal';

type ModalState = 'idle' | 'register' | 'otp' | 'success';

interface LoginPageProps {
  auth: {
    loginByPhone: (phone: string, password: string, rememberMe?: boolean) => Promise<void>;
    loginByUsername: (username: string, password: string, rememberMe?: boolean) => Promise<void>;
    register: (data: { firstName: string; lastName: string; username?: string; email: string; phone: string; password: string; role?: string }) => Promise<unknown>;
  };
}

interface RegistrationData {
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  phone: string;
  password: string;
}

function LoginPage({ auth }: LoginPageProps) {
  const [modalState, setModalState] = useState<ModalState>('idle');
  const [registrationData, setRegistrationData] = useState<RegistrationData | null>(null);

  const handleSignIn = async (username: string, password: string, rememberMe: boolean) => {
    await auth.loginByUsername(username, password, rememberMe);
  };

  const handleRegisterNext = (data: RegistrationData) => {
    setRegistrationData(data);
    setModalState('otp');
  };

  const handleOtpVerified = async () => {
    if (!registrationData) return;
    await auth.register({
      firstName: registrationData.firstName,
      lastName: registrationData.lastName,
      username: registrationData.username,
      email: registrationData.email,
      phone: registrationData.phone,
      password: registrationData.password,
      role: 'GARAGE_OWNER',
    });
    setModalState('success');
  };

  const handleEditPhone = () => {
    setModalState('register');
  };

  const handleCloseModals = () => {
    setModalState('idle');
    setRegistrationData(null);
  };

  const handleSuccessSignIn = () => {
    setModalState('idle');
    setRegistrationData(null);
  };

  return (
    <div className="auth-split-layout">
      <div className="auth-split-form">
        <div className="auth-split-form-inner">
          <SignInForm
            onSubmit={handleSignIn}
            onCreateAccount={() => setModalState('register')}
          />
        </div>
      </div>

      <AuthHeroImage />

      {modalState === 'register' && (
        <RegisterModal
          initialData={registrationData}
          onNext={handleRegisterNext}
          onClose={handleCloseModals}
        />
      )}

      {modalState === 'otp' && registrationData && (
        <OtpModal
          phone={registrationData.phone}
          onVerified={handleOtpVerified}
          onEdit={handleEditPhone}
          onClose={handleCloseModals}
        />
      )}

      {modalState === 'success' && (
        <SuccessModal onSignIn={handleSuccessSignIn} />
      )}
    </div>
  );
}

export default LoginPage;
